import { modals } from "@mantine/modals";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import { Box, Button, Group, Text } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";

const DeleteDataView = ({
  listId,
  onSuccess,
}: {
  listId: number[];
  onSuccess: any;
}) => {
  const handleDelete = async () => {
    const res = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblTemItem/delete",
      listId
    );
    if (res) {
      NotificationExtension.Success("Xóa thành công !");
      setTimeout(() => {
        onSuccess();
        modals.closeAll();
      }, 1000);
    }
  };

  return (
    <Box size={"auto"}>
      <Text size="20px" mt={10} fw={500}>
        Bạn có chắc chắn muốn xóa các tem sản phẩm này ?
      </Text>
      <Group justify="end" mt="lg">
        <Button
          type="button"
          color="red"
          onClick={handleDelete}
          leftSection={<IconCheck size={18} />}
        >
          Xác nhận
        </Button>
      </Group>
    </Box>
  );
};

export default DeleteDataView;
